import type { RouteRecordRaw } from 'vue-router'
import Login from '@/views/Login.vue'
import {ROUTES, API_ENDPOINTS} from '@myorg/type-lib'

export const loginRoute: RouteRecordRaw = {
  path: ROUTES.LOGIN.PATH,
  name: ROUTES.LOGIN.NAME,
  component: Login,
}